import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export interface TaskStatus<TResult = unknown> {
  status: string
  result?: TResult
}

export function useTaskStatus<TResult = unknown>(taskId: string | null) {
  return useQuery<TaskStatus<TResult>>({
    queryKey: [CacheKeys.TASK_STATUS, taskId],
    queryFn: () =>
      axios
        .get(`/api/v1/insure/internal/tasks/${taskId}/status/`)
        .then((res) => toCamelCase(res.data) as TaskStatus<TResult>),
    enabled: !!taskId,
    refetchInterval: (query) => {
      const s = query.state.data?.status
      if (!s || s === 'RUNNING' || s === 'UNKNOWN') return 5000
      return false
    },
  })
}
